import urlConf from '../../conf/urlConf'
import { ConfUtil } from '@vzmi/component_ec_nodejs_util'

const confUtil = new ConfUtil({ conf: urlConf })

export default confUtil
